<template>
  <v-layout class="full" align-center style="margin: 0 0;">
    <v-flex
      v-if="item.type==='shape'"
      :class="['full', { 'builder-oval': item.subtype==='oval' }]"
      :style="getStyles(item)"
    />

    <v-flex
      v-else-if="item.type==='zone' && item.styles.backgroundImage"
      :style="getImageStyles(item)"
      class="full builder-image"
    />

    <v-flex
      v-else-if="item.placeholder"
      :style="getStyles(item)"
    >
      <span> {{ workflowBuilderPlaceholder(item) }} </span>
    </v-flex>

    <v-flex
      v-else-if="item.type==='custom-text'"
      :style="getStyles(item)"
      class="builder-custom-text"
    >
      <v-textarea
        v-model="item.data"
        outline
        hide-details
        autofocus
        :placeholder="adminText('workflowsAll.enter_text_9c05f58', 'Enter text')"
      />
    </v-flex>

    <v-flex
      v-else-if="item.subtype==='avatar'"
      :style="getStyles(item)"
      class="full builder-avatar"
    />

    <v-flex
      v-else-if="item.subtype==='flag'"
      :style="getStyles(item)"
      class="full builder-flag"
    />

    <v-flex
      v-if="item.type==='custom-image'"
      :style="getImageStyles(item)"
      class="full builder-image"
    >
      <custom-image-upload v-if="!item.data" :event-id="eventId" :url.sync="item.data" />
    </v-flex>

    <v-flex
      v-else-if="item.type==='qr-code'"
      :style="getStyles(item)"
      class="full builder-qr-code"
    />

    <v-flex
      v-else-if="item.subtype==='barcode'"
      :style="getStyles(item)"
      class="full builder-barcode"
    />
    <v-flex
      v-else-if="item.type==='printCount'"
      :style="getStyles(item)"
      class="full builder-custom-text"
    />
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'

import { toCSS } from './../../utils'
import CustomImageUpload from './custom-image-upload.vue'

export default {
  mixins: [WorkflowDisplay],
  name: 'item',
  components: {
    'custom-image-upload': CustomImageUpload,
  },
  props: {
    data: Object,
    eventId: String,
  },
  data() {
    return {
      item: this.data,
    }
  },
  watch: {
    data(value) {
      this.item = value
    },
  },
  methods: {
    getStyles({ styles }) {
      const { rotate, ...rest } = styles

      return toCSS(rest)
    },
    getImageStyles({ styles, data }) {
      const backgroundImage = data || styles.backgroundImage

      return toCSS({ ...styles, backgroundImage })
    },
  },
}
</script>

<style scoped>
.builder-custom-text {
  width: 100%;
  height: 100%;
  padding: 10px !important;
}

.builder-custom-text >>> .v-input, .builder-custom-text >>> .v-input .v-input__control {
  height: 100%;
  padding: 0;
}

.builder-custom-text >>> .v-input .v-input__slot {
  padding: 0;
  border: none !important;
  height: 100%;
}

.builder-custom-text >>> .v-input .v-input__slot textarea {
  padding: 0;
  margin: 0;
  resize: none;
  height: 100%;
}

.builder-custom-text >>> .v-input .v-text-field__slot {
  margin: 0;
}
</style>

